import { useState } from "react";
import { TimeStampToJalali } from "../../utils/helperFunction";
import BankAccountList from "./customerModal/BankAccountList";
export default function InfoTab({
  customerData,
  bankName,
  setCustomerUpdater
}) {
  const [corporate, setCorporate] = useState(false);

  return (
    <div>
      {/* <div className="d-flex mt-4">
        <div className="w-50">عنوان</div>
        <div className="w-50">مشتری</div>
      </div> */}

      <div className="d-flex mt-4">
        <div className="w-50">عنوان</div>
        <div className="w-50">
          {customerData.corporate == 1
            ? `${customerData.company_name}(${customerData.firstname}
            ${customerData.lastname})`
            : `${customerData.firstname} ${customerData.lastname}`}
        </div>
      </div>
      <div className="d-flex mt-4">
        <div className="w-50">کاربر اصلی</div>
        <div className="w-50">
          {customerData.main_uid[0]?.label
            ? customerData.main_uid[0]?.label
            : "-----"}
        </div>
      </div>
      <div className="d-flex mt-4">
        <div className="w-50">شماره تماس</div>
        <div className="w-50">{customerData.mobile}</div>
      </div>

      <div className="d-flex mt-4">
        <div className="w-50">تاریخ ثبت</div>
        {customerData.mtm != "" ? (
          <div className="w-50">
            {TimeStampToJalali(customerData.mtm * 1000)}
          </div>
        ) : (
          <div className="w-50">---</div>
        )}
      </div>
      <div className="d-flex mt-4">
        <div className="w-50">تاریخ اولین فاکتور</div>
        {customerData.first_factor_tm != "" ? (
          <div className="w-50">
            {TimeStampToJalali(customerData.first_factor_tm * 1000)}
          </div>
        ) : (
          <div className="w-50">---</div>
        )}
      </div>
      <div className="d-flex mt-4">
        <div className="w-50">تعداد خرید</div>
        <div className="w-50">{customerData.purchase_count}</div>
      </div>
      <div className="d-flex mt-4">
        <div className="w-50">حجم خرید</div>
        <div className="w-50">{customerData.purchase_volume}</div>
      </div>

      <div className="d-flex mt-4">
        <div className="w-50">برچسب ها</div>
        <div className=" d-flex flex-wrap w-50">
          {customerData.tag_links.length > 0
            ? customerData.tag_links.map((v, i) => (
                <span>
                  {v.label}
                  {i < customerData.tag_links.length - 1 ? "," : ""}
                </span>
              ))
            : "----"}
        </div>
      </div>
      <div>
        <h6 className="mt-5">اطلاعات بانکی</h6>
        <BankAccountList
          data={customerData.bank_accounts}
          bankName={bankName}
          setCustomerUpdater={setCustomerUpdater}
        />
        {/* {bank.map((value) => {
          return (
            <div
              className={`border rounded mt-3 p-2 ${
                value.active == true
                  ? "text-success border-success"
                  : "text-danger border-danger"
              } `}
            >
              <div className="d-flex mt-2">
                <div className="w-50">نام بانک</div>
                <div className="w-50">{value.bankId}</div>
              </div>
              <div className="d-flex mt-4">
                <div className="w-50">شماره حساب</div>
                <div className="w-50">{value.account}</div>
              </div>
              <div className="d-flex mt-4">
                <div className="w-50">شماره کارت</div>
                <div className="w-50">{value.cart}</div>
              </div>
              <div className="d-flex mt-4">
                <div className="w-50">شماره شبا</div>
                <div className="w-50">{value.sheba}</div>
              </div>
              <div className="d-flex mt-4">
                <div className="w-50">وضعیت</div>
                <div className="w-50">
                  {value.active == true ? "فعال" : "غیر فعال"}
                </div>
              </div>
            </div>
          );
        })} */}
      </div>
    </div>
  );
}
